export const ENGINEERING_BASE_PATH = '/engineering';

export const ENGINEERING_TAB_ROUTES = Object.freeze([
  { key: 'calculators', path: '/engineering/calculators' },
  { key: 'engineeringCalendar', path: '/engineering/calendar' },
  { key: 'assignedJobs', path: '/engineering/assigned-jobs' },
  { key: 'engineerPto', path: '/engineering/pto-management' },
  { key: 'taskManagement', path: '/engineering/task-management' },
  { key: 'myTasks', path: '/engineering/my-tasks' },
  { key: 'protectedTime', path: '/engineering/protected-time' },
  { key: 'mechanicalReview', path: '/engineering/mechanical-review' },
  { key: 'mechanicalReference', path: '/engineering/mechanical-reference' },
  { key: 'panelSizing', path: '/engineering/panel-sizing' },
  { key: 'changeOrderTasks', path: '/engineering/change-order-tasks' },
]);

export const ENGINEERING_CONTAINER_PATHS = Object.freeze([
  ENGINEERING_BASE_PATH,
  ...ENGINEERING_TAB_ROUTES.map(({ path }) => path),
]);

const normalizePath = (pathname = '') => {
  const normalizedPath = String(pathname).replace(/\/+$/, '').toLowerCase();
  return normalizedPath || '/';
};

const TAB_BY_PATH = Object.freeze(
  Object.fromEntries(
    ENGINEERING_TAB_ROUTES.map(({ key, path }) => [normalizePath(path), key])
  )
);

const PATH_BY_TAB = Object.freeze(
  Object.fromEntries(
    ENGINEERING_TAB_ROUTES.map(({ key, path }) => [key, path])
  )
);

export const getEngineeringTabFromPath = (pathname) => (
  TAB_BY_PATH[normalizePath(pathname)] || null
);

export const getEngineeringPathForTab = (tabKey) => (
  PATH_BY_TAB[tabKey] || ENGINEERING_BASE_PATH
);
